import { connect } from "react-redux";
import { actions } from "../../../../redux/modules/station/station";
import { formValueSelector } from "redux-form";


import Create from "./Create";

const selector = formValueSelector('StationForm');
const ms2p = (state) => {
    return {
        ...state.station,
        vehicles: { ...state.vehicles },
        users: { ...state.users },
        formLat: selector(state, 'lat'),
        formLng: selector(state, 'lng'),
    };
};

const md2p = {
    ...actions,
};

export default connect(ms2p, md2p)(Create);
